<!-- Overrides @basecom-gmbh/pond/components/Layout/LayoutFooter.vue -->
<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { getTranslatedProperty, getCategoryRoute } from '@shopware-pwa/helpers-next';

const { navigationElements: serviceNavigationElements, loadNavigationElements: loadServiceElements } = useNavigation({
    type: 'service-navigation',
});

onMounted(async () => {
    await loadServiceElements({ depth: 1 });
});
</script>

<template>
    <!-- IDS-48 - Change colors-->
    <div class="mt-auto">
        
<FormKitLazyProvider config-file="true">
<footer class="mt-20 bg-brand-primary py-12">
            <div class="container">
                <div class="items-center md:flex md:justify-between">
                    <div class="md:flex md:gap-10">
                        <!-- social media links -->
                        <div class="mb-4 flex gap-8 lg:mb-0">
                            <NuxtLink
                                to="https://www.linkedin.com/company/ids-online-gmbh?originalSubdomain=de"
                                target="_blank"
                            >
                                <FormKitIcon
                                    icon="linkedin"
                                    class="block h-6 w-6"
                                />
                            </NuxtLink>
                            <NuxtLink
                                to="https://www.facebook.com/ids.online.gmbh"
                                target="_blank"
                            >
                                <FormKitIcon
                                    icon="facebook"
                                    class="block h-6 w-6"
                                />
                            </NuxtLink>
                        </div>

                        <!-- footer service navigation -->
                        <ul class="flex list-none space-x-1 text-md font-normal">
                            <span>
                                {{ $t('global.footer.copyright') }}
                            </span>
                            <li
                                v-for="navigationElement in serviceNavigationElements"
                                :key="navigationElement.id"
                                class="space-x-1"
                            >
                                <span>I</span>
                                <!-- separator between the links -->
                                <NuxtLink
                                    :target="
                                        navigationElement.externalLink || navigationElement.linkNewTab ? '_blank' : ''
                                    "
                                    :to="getCategoryRoute(navigationElement)"
                                    class="underline"
                                >
                                    {{ getTranslatedProperty(navigationElement, 'name') }}
                                </NuxtLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
</FormKitLazyProvider>

    </div>
</template>
